var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.828,
    height: 18.809,
    viewBox: "0 0 18.828 18.809",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pencil",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M11.627,82.473,1.268,92.833a.413.413,0,0,0-.108.189L.012,97.631a.408.408,0,0,0,.4.507.405.405,0,0,0,.1-.012l4.609-1.148A.407.407,0,0,0,5.3,96.87l10.36-10.36Zm0,0",
    transform: "translate(0 -79.329)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M339.778,1.978,338.625.824a2.088,2.088,0,0,0-2.884,0l-1.413,1.413,4.037,4.037,1.413-1.413a2.04,2.04,0,0,0,0-2.884Zm0,0",
    transform: "translate(-321.547 -0.247)",
    fill: "#b3b3b3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e46fa14d6e5af3d1112d31d9ec4afdf8.svg";
export { ForwardRef as ReactComponent };